import React from 'react';
import * as S from './postfix.styles';

export const Postfix: React.FunctionComponent<{ children: React.ReactNode }> = (props): React.ReactElement => {
    return <S.Postfix>{props.children}</S.Postfix>;
};
